import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKey = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 19 11",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.1585 4.33311H10.5418C9.75015 2.09144 7.40849 0.583109 4.80849 1.09978C2.90015 1.48311 1.35015 3.01644 0.950153 4.91644C0.26682 8.14978 2.71682 10.9998 5.83349 10.9998C8.00849 10.9998 9.85849 9.60811 10.5418 7.66644H10.8335L11.9085 8.74144C12.2335 9.06644 12.7585 9.06644 13.0835 8.74144L14.1668 7.66644L15.2418 8.74144C15.5668 9.06644 16.1002 9.06644 16.4252 8.74144L18.5835 6.56644C18.9085 6.24144 18.9085 5.70811 18.5752 5.38311L17.7502 4.57478C17.5835 4.41644 17.3752 4.33311 17.1585 4.33311ZM5.83349 8.49978C4.45849 8.49978 3.33349 7.37478 3.33349 5.99978C3.33349 4.62478 4.45849 3.49978 5.83349 3.49978C7.20849 3.49978 8.33349 4.62478 8.33349 5.99978C8.33349 7.37478 7.20849 8.49978 5.83349 8.49978Z" })
});
export default SvgKey;
